export default {
  DvcCommon: {
    Master: {
      //Tiền mặt tại KB/Tiền mặt tại NH
      payment_type: 'payment_type',
      proficient: 'proficient',
      budget_code: 'budget_code',
      //Năm NS
      budget_year: 'budget_year',
      dvc_file_id: 'dvc_file_id',
      //Người nhận
      //Họ và tên
      receive_money_code: 'receive_money_code',
      receive_money_id: 'receive_money_id',
      //Tên đơn vị
      receive_money_name: 'receive_money_name',
      //Số chứng từ giấy
      ref_no_paper: 'ref_no_paper',
      is_from_voucher: 'is_from_voucher',
      journal_memo: 'journal_memo',
      dvc_cash_with_draw_id: 'dvc_cash_with_draw_id',
      dvc_cash_with_draw_type: 'dvc_cash_with_draw_type',
      dvc_cash_with_draw_voucher_id: 'dvc_cash_with_draw_voucher_id',
    },
    Detail: {
      // Số CT gốc
      // Ngày CT gốc
      org_voucher_date: 'org_voucher_date',
      org_voucher_no: 'org_voucher_no',
      // Số hóa đơn
      // Ngày hóa đơn
      inv_date: 'inv_date',
      inv_no: 'inv_no',
      // Nội dung thanh toán
      description: 'description',
      // Nguồn
      budget_source_code: 'budget_source_code',
      budget_source_id: 'budget_source_id',
      budget_source_name: 'budget_source_name',
      // Mã dự phòng
      // Chương
      // Khoản
      // Mục
      // Tiểu mục
      budget_chapter_code: 'budget_chapter_code',
      budget_item_code: 'budget_item_code',
      budget_item_detail_code: 'budget_item_detail_code',
      budget_kind_item_code: 'budget_kind_item_code',
      budget_sub_item_code: 'budget_sub_item_code',
      budget_sub_kind_item_code: 'budget_sub_kind_item_code',
      // Số tiền
      amount: 'amount',
      // Số lượng
      // Định mức
      // Đơn giá
      // Tiết
      // Hoạt động
      activity_code: 'activity_code',
      activity_id: 'activity_id',
      // NDCP
      // Mã thống kê
      cash_withdraw_type_id: 'cash_withdraw_type_id',
      cash_withdraw_type_name: 'cash_withdraw_type_namen',

      project_code: 'project_code',
      project_id: 'project_id',
      accounting_object_code: 'accounting_object_code',
      accounting_object_id: 'accounting_object_id',
      fund_id: 'fund_id',
      fund_name: 'fund_name',
      fund_structure_code: 'fund_structure_code',
      fund_structure_id: 'fund_structure_id',

      is_clear_reference: 'is_clear_reference',
      method_distribute_id: 'method_distribute_id',
      method_distribute_name: 'method_distribute_name',

      statistic_code: 'statistic_code',
      statistic_id: 'statistic_id',
      quantity: 'quantity',
      real_unit_price: 'real_unit_price',
      sort_order: 'sort_order',
      unit_price: 'unit_price',
      dvc_cash_with_draw_voucher_id: 'dvc_cash_with_draw_voucher_id',
      dvc_cash_with_draw_voucher_detail_id: 'dvc_cash_with_draw_voucher_detail_id',
    },
  },
  //* 1'Rút dự toán tiền mặt'
  TreasuryCash: {
    Master: {
      bu_commitment_request_ref_no: 'bu_commitment_request_ref_no',
      contract_frame_no: 'contract_frame_no',
      project_code: 'project_code',
      project_id: 'project_id',
      project_name: 'project_name',
      identification_number: 'identification_number',
      issue_by: 'issue_by',
      issue_date: 'issue_date',
      tax_payer_bank_name: 'tax_payer_bank_name',
      tax_payer_budget_chapter_code: 'tax_payer_budget_chapter_code',
      tax_payer_budget_sub_item: 'tax_payer_budget_sub_item',
      tax_payer_issue_tax: 'tax_payer_issue_tax',
      tax_payer_name: 'tax_payer_name',
      tax_payer_organization_code: 'tax_payer_organization_code',
      tax_payer_organization_name: 'tax_payer_organization_name',
      tax_payer_tax_code: 'tax_payer_tax_code',
      tax_payer_bank_code: 'tax_payer_bank_code',
      tax_payer_bank_name: 'tax_payer_bank_name',
    },
    Detail: {
      bank_account: 'bank_account',
      budget_source_property: 'budget_source_property',
      budget_source_property_name: 'budget_source_property_name',
      payment: 'payment',
      tax_amount: 'tax_amount',
    },
  },
  //*  2,  'Rút dự toán chuyển khoản',
  TreasuryTransfer: {
    Master: {
      receive_money_address: 'receive_money_address',
      receive_money_bank_account: 'receive_money_bank_account',
      receive_money_bank_code: 'receive_money_bank_code',
      receive_money_bank_name: 'receive_money_bank_name',
      receive_money_open_at: 'receive_money_open_at',
      bu_commitment_request_ref_no: 'bu_commitment_request_ref_no',
      contract_frame_no: 'contract_frame_no',
      project_code: 'project_code',
      project_id: 'project_id',
      project_name: 'project_name',
      tax_payer_bank_name: 'tax_payer_bank_name',
      tax_payer_budget_chapter_code: 'tax_payer_budget_chapter_code',
      tax_payer_budget_sub_item: 'tax_payer_budget_sub_item',
      tax_payer_issue_tax: 'tax_payer_issue_tax',
      tax_payer_name: 'tax_payer_name',
      tax_payer_organization_code: 'tax_payer_organization_code',
      tax_payer_organization_name: 'tax_payer_organization_name',
      tax_payer_tax_code: 'tax_payer_tax_code',
      tax_payer_bank_code: 'tax_payer_bank_code',
      tax_payer_bank_name: 'tax_payer_bank_name',
    },

    Detail: {
      bank_account: 'bank_account',
      budget_source_property: 'budget_source_property',
      budget_source_property_name: 'budget_source_property_name',
      payment: 'payment',
      tax_amount: 'tax_amount',
    },
    Payment: {
      accounting_object_name: 'accounting_object_name',
      bank_account: 'bank_account',
      benefit_amount: 'benefit_amount',
      bonus_amount: 'bonus_amount',
      contract_amount: 'contract_amount',
      dvc_cash_with_draw_voucher_id: 'dvc_cash_with_draw_voucher_id',
      dvc_cash_with_draw_voucher_payment_id: 'dvc_cash_with_draw_voucher_payment_id',
      increased_income_amount: 'increased_income_amount',
      labor_salary_amount: 'labor_salary_amount',
      note: 'note',
      salary_benefit_amount: 'salary_benefit_amount',
      scholarship_amount: 'scholarship_amount',
      sort_order: 'sort_order',
      state_bank_name: 'state_bank_name',
      target: 'target',
      total_amount: 'total_amount',
    },
  },
  //* '3 Rút dự toán về tài khoản tiền gửi',
  TreasuryToAccountCash: {
    Master: {
      receive_money_bank_account: 'receive_money_bank_account',
      receive_money_bank_code: 'receive_money_bank_code',
      receive_money_bank_name: 'receive_money_bank_name',
      receive_money_open_at: 'receive_money_open_at',
      bu_commitment_request_ref_no: 'bu_commitment_request_ref_no',
      contract_frame_no: 'contract_frame_no',
      project_code: 'project_code',
      project_id: 'project_id',
      project_name: 'project_name',
      tax_payer_bank_name: 'tax_payer_bank_name',
      tax_payer_budget_chapter_code: 'tax_payer_budget_chapter_code',
      tax_payer_budget_sub_item: 'tax_payer_budget_sub_item',
      tax_payer_issue_tax: 'tax_payer_issue_tax',
      tax_payer_name: 'tax_payer_name',
      tax_payer_organization_code: 'tax_payer_organization_code',
      tax_payer_organization_name: 'tax_payer_organization_name',
      tax_payer_tax_code: 'tax_payer_tax_code',
      tax_payer_bank_code: 'tax_payer_bank_code',
      tax_payer_bank_name: 'tax_payer_bank_name',
    },

    Detail: {
      payment: 'payment',
      tax_amount: 'tax_amount',
      bank_account: 'bank_account',
      budget_source_property: 'budget_source_property',
      budget_source_property_name: 'budget_source_property_name',
    },
    Payment: {
      accounting_object_name: 'accounting_object_name',
      bank_account: 'bank_account',
      benefit_amount: 'benefit_amount',
      bonus_amount: 'bonus_amount',
      contract_amount: 'contract_amount',
      dvc_cash_with_draw_voucher_id: 'dvc_cash_with_draw_voucher_id',
      dvc_cash_with_draw_voucher_payment_id: 'dvc_cash_with_draw_voucher_payment_id',
      increased_income_amount: 'increased_income_amount',
      labor_salary_amount: 'labor_salary_amount',
      note: 'note',
      salary_benefit_amount: 'salary_benefit_amount',
      scholarship_amount: 'scholarship_amount',
      sort_order: 'sort_order',
      state_bank_name: 'state_bank_name',
      target: 'target',
      total_amount: 'total_amount',
    },
  },
  //* 4, //'Rút tiền gửi KB về tiền mặt',
  TreasuryDepositsToCash: {
    Master: {
      identification_number: 'identification_number',
      issue_by: 'issue_by',
      issue_date: 'issue_date',
    },
    Detail: {},
  },
  // * 5,Chi tiền gửi tại Kho bạc,
  SpendTransfer: {
    Master: {
      receive_money_address: 'receive_money_address',
      receive_money_bank_account: 'receive_money_bank_account',
      receive_money_bank_code: 'receive_money_bank_code',
      receive_money_bank_name: 'receive_money_bank_name',
      receive_money_open_at: 'receive_money_open_at',

      tax_payer_bank_name: 'tax_payer_bank_name',
      tax_payer_budget_chapter_code: 'tax_payer_budget_chapter_code',
      tax_payer_budget_sub_item: 'tax_payer_budget_sub_item',
      tax_payer_issue_tax: 'tax_payer_issue_tax',
      tax_payer_name: 'tax_payer_name',
      tax_payer_organization_code: 'tax_payer_organization_code',
      tax_payer_organization_name: 'tax_payer_organization_name',
      tax_payer_tax_code: 'tax_payer_tax_code',
      tax_payer_bank_code: 'tax_payer_bank_code',
      tax_payer_bank_name: 'tax_payer_bank_name',
    },
    Detail: {
      payment: 'payment',
      tax_amount: 'tax_amount',
    },
  },

  //* 7, 'Rút vốn đầu tư bằng chuyển khoản',
  InvestmentWithTransfer: {
    Master: {
      receive_money_address: 'receive_money_address',
      receive_money_bank_account: 'receive_money_bank_account',
      receive_money_bank_code: 'receive_money_bank_code',
      receive_money_bank_name: 'receive_money_bank_name',
      receive_money_open_at: 'receive_money_open_at',
      bu_commitment_request_ref_no: 'bu_commitment_request_ref_no',
      contract_frame_no: 'contract_frame_no',
      project_code: 'project_code',
      project_id: 'project_id',
      project_name: 'project_name',
      tax_payer_bank_name: 'tax_payer_bank_name',
      tax_payer_budget_chapter_code: 'tax_payer_budget_chapter_code',
      tax_payer_budget_sub_item: 'tax_payer_budget_sub_item',
      tax_payer_issue_tax: 'tax_payer_issue_tax',
      tax_payer_name: 'tax_payer_name',
      tax_payer_organization_code: 'tax_payer_organization_code',
      tax_payer_organization_name: 'tax_payer_organization_name',
      tax_payer_tax_code: 'tax_payer_tax_code',
      tax_payer_bank_code: 'tax_payer_bank_code',
      tax_payer_bank_name: 'tax_payer_bank_name',
      accounting_object_name_sent_name: 'accounting_object_name_sent_name',
      accumulated_volume: 'accumulated_volume',
      advance_balance: 'advance_balance',
      beneficiary_domestic_amount: 'beneficiary_domestic_amount',
      beneficiary_foreign_amount: 'beneficiary_foreign_amount',
      budget_code: 'budget_code',
      budget_name: 'budget_name',
      budget_short_name: 'budget_short_name',
      budget_year: 'budget_year',
      capital_plan_year: 'capital_plan_year',
      capital_source: 'capital_source',
      contract_addendum_date: 'contract_addendum_date',
      contract_addendum_no: 'contract_addendum_no',
      contract_amount_date: 'contract_amount_date',
      contract_amount_no: 'contract_amount_no',
      contract_code: 'contract_code',
      contract_date: 'contract_date',
      contract_no: 'contract_no',
      decision_number: 'decision_number',
      decision_number_date: 'decision_number_date',
      domestic_bank_account: 'domestic_bank_account',
      domestic_bank_code: 'domestic_bank_code',
      domestic_bank_name: 'domestic_bank_name',
      foreign_bank_account: 'foreign_bank_account',
      foreign_bank_code: 'foreign_bank_code',
      foreign_bank_name: 'foreign_bank_name',
      investor_code: 'investor_code',
      investor_name: 'investor_name',
      payment_investment_date: 'payment_investment_date',
      payment_investment_no: 'payment_investment_no',
      suggestion_plan: 'suggestion_plan',
      tax_domestic_amount: 'tax_domestic_amount',
      tax_foreign_amount: 'tax_foreign_amount',
      unit_project_code: 'unit_project_code',
      unit_project_name: 'unit_project_name',
      warranty_domestic_amount: 'warranty_domestic_amount',
      warranty_foreign_amount: 'warranty_foreign_amount',
      with_draw_domestic_amount: 'with_draw_domestic_amount',
      with_draw_foreign_amount: 'with_draw_foreign_amount',
    },
    Detail: {
      budget_source_property: 'budget_source_property',
      budget_source_property_name: 'budget_source_property_name',
      bank_account: 'bank_account',
      payment: 'payment',
      tax_amount: 'tax_amount',
      estimate_amount: 'estimate_amount',
      accumulated_amount: 'accumulated_amount',
    },
  },
  //* 8, 'Rút vốn đầu tư bằng tiền mặt',
  InvestmentWithCash: {
    Master: {
      identification_number: 'identification_number',
      issue_by: 'issue_by',
      issue_date: 'issue_date',
      //*? các trường này k có ở nv chi tiền gửi và Rút tiền gửi KB về tiền mặt
      bu_commitment_request_ref_no: 'bu_commitment_request_ref_no',
      contract_frame_no: 'contract_frame_no',
      project_code: 'project_code',
      project_id: 'project_id',
      project_name: 'project_name',
      tax_payer_bank_name: 'tax_payer_bank_name',
      tax_payer_budget_chapter_code: 'tax_payer_budget_chapter_code',
      tax_payer_budget_sub_item: 'tax_payer_budget_sub_item',
      tax_payer_issue_tax: 'tax_payer_issue_tax',
      tax_payer_name: 'tax_payer_name',
      tax_payer_organization_code: 'tax_payer_organization_code',
      tax_payer_organization_name: 'tax_payer_organization_name',
      tax_payer_tax_code: 'tax_payer_tax_code',
      tax_payer_bank_code: 'tax_payer_bank_code',
      tax_payer_bank_name: 'tax_payer_bank_name',
      accounting_object_name_sent_name: 'accounting_object_name_sent_name',
      accumulated_volume: 'accumulated_volume',
      advance_balance: 'advance_balance',
      beneficiary_domestic_amount: 'beneficiary_domestic_amount',
      beneficiary_foreign_amount: 'beneficiary_foreign_amount',
      budget_code: 'budget_code',
      budget_name: 'budget_name',
      budget_short_name: 'budget_short_name',
      budget_year: 'budget_year',
      capital_plan_year: 'capital_plan_year',
      capital_source: 'capital_source',
      contract_addendum_date: 'contract_addendum_date',
      contract_addendum_no: 'contract_addendum_no',
      contract_amount_date: 'contract_amount_date',
      contract_amount_no: 'contract_amount_no',
      contract_code: 'contract_code',
      contract_date: 'contract_date',
      contract_no: 'contract_no',
      decision_number: 'decision_number',
      decision_number_date: 'decision_number_date',
      domestic_bank_account: 'domestic_bank_account',
      domestic_bank_code: 'domestic_bank_code',
      domestic_bank_name: 'domestic_bank_name',
      foreign_bank_account: 'foreign_bank_account',
      foreign_bank_code: 'foreign_bank_code',
      foreign_bank_name: 'foreign_bank_name',
      investor_code: 'investor_code',
      investor_name: 'investor_name',
      payment_investment_date: 'payment_investment_date',
      payment_investment_no: 'payment_investment_no',
      suggestion_plan: 'suggestion_plan',
      tax_domestic_amount: 'tax_domestic_amount',
      tax_foreign_amount: 'tax_foreign_amount',
      unit_project_code: 'unit_project_code',
      unit_project_name: 'unit_project_name',
      warranty_domestic_amount: 'warranty_domestic_amount',
      warranty_foreign_amount: 'warranty_foreign_amount',
      with_draw_domestic_amount: 'with_draw_domestic_amount',
      with_draw_foreign_amount: 'with_draw_foreign_amount',
    },
    Detail: {
      bank_account: 'bank_account',
      budget_source_property: 'budget_source_property',
      budget_source_property_name: 'budget_source_property_name',
      payment: 'payment',
      tax_amount: 'tax_amount',
      estimate_amount: 'estimate_amount',
      accumulated_amount: 'accumulated_amount',
    },
  },
};
